import {
  Button,
  Dialog,
  DialogContent,
  CardHeader,
  CardContent,
  CardActions,
  Typography,
  List,
  ListItem,
  Divider,
} from "../../../../components";

const ResultadoEmissaoLoteDialog = ({ open, resultado }) => {
  const totalSucessos = resultado?.sucessos?.length || 0;
  const totalErros = resultado?.erros?.length || 0;

  return (
    <Dialog disableEscapeKeyDown maxWidth="md" fullWidth open={open}>
      <DialogContent>
        <CardHeader title="Resultado da Emissão em Lote" />
        <CardContent>
          {totalSucessos > 0 && (
            <>
              <Typography>
                <i
                  className="ph-fill ph-check-circle"
                  style={{ marginRight: 8 }}
                ></i>
                Notas Emitidas com Sucesso ({totalSucessos})
              </Typography>
              <List dense style={{ maxHeight: 200, overflow: "auto" }}>
                {resultado.sucessos.map((sucesso, index) => (
                  <ListItem key={index}>
                    <i
                      className="ph-fill ph-circle"
                      style={{ color: "#28a745" }}
                    ></i>
                    <Typography variant="body2" style={{ marginLeft: 8 }}>
                      {sucesso}
                    </Typography>
                  </ListItem>
                ))}
              </List>
              {totalErros > 0 && (
                <Divider
                  sx={{ my: 2, border: "1px solid grey", width: "100%" }}
                />
              )}
            </>
          )}

          {totalErros > 0 && (
            <>
              <Typography>
                <i
                  className="ph-fill ph-x-circle"
                  style={{ marginRight: 8 }}
                ></i>
                Notas Com Erro ({totalErros})
              </Typography>
              <List dense style={{ maxHeight: 200, overflow: "auto" }}>
                {resultado.erros.map((erro, index) => (
                  <ListItem key={index}>
                    <i
                      className="ph-fill ph-circle"
                      style={{ color: "#dc3545" }}
                    ></i>
                    <Typography variant="body2" style={{ marginLeft: 8 }}>
                      {erro}
                    </Typography>
                  </ListItem>
                ))}
              </List>
            </>
          )}

          {totalSucessos === 0 && totalErros === 0 && (
            <Typography className="text-center" style={{ padding: "20px" }}>
              Nenhuma nota foi processada.
            </Typography>
          )}
        </CardContent>
        <CardActions className="d-flex justify-content-end">
          <Button
            variant="contained"
            color="padrao"
            onClick={() => {
              window.location.reload();
            }}
          >
            Fechar e Recarregar
            <i
              className="ph-fill ph-arrow-clockwise"
              style={{ fontSize: 22, marginLeft: 10 }}
            ></i>
          </Button>
        </CardActions>
      </DialogContent>
    </Dialog>
  );
};

export default ResultadoEmissaoLoteDialog;
